import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeleteMealLogDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteMealLogDialog: React.FC<DeleteMealLogDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Meal Log"
      message="Are you sure you want to delete this meal log?"
      confirmLabel="Delete"
      severity="error"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteMealLogDialog;
